import { motion } from "framer-motion";
import { CalendarCheck, ArrowDown, Clock } from "lucide-react";
import { IMAGES, CREDENTIALS } from "../data";
import { useBooking } from "../BookingContext";

export default function Hero() {
  const { openBooking } = useBooking();

  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Construction site" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#050A15]/85" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050A15] via-[#050A15]/60 to-[#050A15]/40" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 pb-20 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#D4AF37]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#D4AF37]">
              Safety • Compliance • Leadership
            </span>
          </div>

          <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl font-black uppercase tracking-tighter leading-[0.92]">
            Build Your Career
            <br />
            <span className="gold-text">On This Rock</span>
          </h1>

          <p className="mt-8 text-lg md:text-xl text-[#A3A8B8] max-w-2xl leading-relaxed">
            Authorized OSHA 10 &amp; 30 outreach training, corporate safety programs, and keynote
            speaking — led by a master trainer with 40 years in the construction and general industry.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-book-btn"
              onClick={() => openBooking("")}
              className="pulse-gold inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#050A15] hover:bg-[#F0C84B] font-bold uppercase tracking-wider px-8 py-4 transition-colors"
            >
              <CalendarCheck size={18} /> Book a Live Session
            </button>
            <a
              href="#pillars"
              className="inline-flex items-center justify-center gap-2 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 font-bold uppercase tracking-wider px-8 py-4 transition-colors"
            >
              Explore Training <ArrowDown size={18} />
            </a>
          </div>

          <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#A3A8B8]">
            <Clock size={15} className="text-[#D4AF37]" />
            Free 15-minute consultation — no obligation
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#1D2847] border border-[#1D2847] max-w-4xl"
        >
          {CREDENTIALS.map((c) => (
            <div key={`${c.value}-${c.label}`} className="bg-[#050A15] p-6">
              <div className="font-display text-3xl md:text-4xl font-black gold-text">{c.value}</div>
              <div className="mt-2 text-xs uppercase tracking-wider text-[#A3A8B8] leading-snug">{c.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
